import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  type: 'single',
  header: {
    text: 'FILTER'
  },
  list: [{
    label: 'text 1'
  }, {
    label: 'text 2'
  }, {
    label: 'text 3'
  }, {
    label: 'text 4'
  }, {
    label: 'text 5'
  }],
  shouldAllowToggle: true
}, getTestId('FilterWidgetContainer'));